import React from "react"
import {
    GetCurrentUser
} from "../utils/hooks"
import {
    Loader
} from "../components/index"
import { useNavigate } from "react-router-dom"
import _ from "lodash"
import { useLazyGetInstitutionClassesQuery } from "../Redux/actions/classSetup.action"
import {
    useLazyGetFeeCollectionReportsQuery
} from "../Redux/actions/feeCollection.action"

export default function Reports(){
    const navigate = useNavigate()
    const [user,setUser] = React.useState(GetCurrentUser())
    const [classList,setClassList] = React.useState([])

    const [getClasses,getClassState] = useLazyGetInstitutionClassesQuery()
    const [getReports,getReportsState] = useLazyGetFeeCollectionReportsQuery()

    React.useEffect(()=>{
        fetchUserData()
    },[user])
    React.useEffect(()=>{
        if(getClassState.status === "fulfilled"){
            const data = _.get(getClassState,"currentData.list",[])
            setClassList(data)
        }
    },[getClassState.status])
    console.log(getReportsState)

    

    function fetchUserData(){
        if(!user) return
        const user_platform = _.get(user,"meta_data.user_platform",null)
        if(user_platform){
            getClasses({
                institution_ref:user_platform
            })
            getReports({
                school_id:user_platform,
                collection_type:"Monthly_Fee"
            })
        }
    }
    return(
        <div className="col-ms-12">
            <h1>Reports</h1>
            {
                (
                    getClassState.isLoading ||
                    getReportsState.isLoading
                ) && (
                    <Loader 
                       show={true}
                    />
                )
            }
        </div>
    )
}